import {defineStore} from "pinia";

export const useCustomerStore = defineStore('customer', {
    state: () => ({
        customer: null
    }),
    actions: {
        clearCustomer() {
            this.customer = null
        }
    }
})
